//require("dotenv").config({ path: ".env.local" }); omentado cambio pnpm

export const APP_NAME=process.env.REACT_APP_NAME;

//key del local storage
export const TOKEN = "token";
export const SERVER_FRONTEND_HOST=process.env.REACT_APP_SERVER_FRONTEND_HOST;

export const API_SERVER_BACKEND={
    HOST_AUTH: process.env.REACT_APP_API_SERVER_BACKEND_HOST_AUTH,
    HOST_DOCUMENT_LOADER:process.env.REACT_APP_API_SERVER_BACKEND_HOST_DOCUMENT_LOADER,
    HOST_MESSAGE: process.env.REACT_APP_API_SERVER_BACKEND_HOST_MESSAGE,
    AUTH: "/api/v1/auth",
    USER: "/api/v1/users",
    INTENT: "/api/v1/intents",
    MESSAGE: "/api/v1/messages",
    FILE : "/api/v1/files"
};
export const STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZE: 401,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  BOOLEAN_TRUE: true,
  BOOLEAN_FALSE: false,
  NUMBER_ENABLE: 1,
  NUMBER_DISABLE: 0,
};

export const HTTP_METHODS = {
  REQUEST_GET: "GET",
  REQUEST_HEAD: "HEAD",
  REQUEST_POST: "POST",
  REQUEST_PUT: "PUT",
  REQUEST_DELETE: "DELETE",
  REQUEST_PATCH: "PATCH",
};

export const AUDIT_APP={
  UPDATE_BY: "app-web",
  CREATE_BY: "app-web",
};

export const FORMAT_APP={
    DATE_DD_MM_YYYY: "dd/MM/yyyy",
    DATE_DD_MM_YYYY_HH_MM: "dd/MM/yyyy hh:mm",
}

export const MESSAGE_ROLE= {
  SENDER_CHATBOT: "bot",
  SENDER_USER: 'user'
}

export const SUPER_USER_ROL=1
